import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Favorite: FC<SvgIconProps> = (props) => (
  <SvgIcon width="100%" height="100%" viewBox="0 0 512 512" {...props}>
    <path
      className="st0"
      d="M471.5,276.8L471.5,276.8C598.1,125,399.6-52.3,265.1,64.7c-5.3,4.6-13.3,4.8-18.7,0.2
	C101.2-57.3-82.3,136.9,40.1,276.8c2.1,2.2,131.7,137.7,189,197.6c14.5,15.2,38.8,15.2,53.3,0C339.2,415.1,466.6,281.9,471.5,276.8z
	"
    />
  </SvgIcon>
);

export default Favorite;
